import * as Yup from 'yup';

import { CustomFormProps } from '@FormModels/shared';

export const formItems = (confirmView: boolean): CustomFormProps => ({
    email: {
        validation: !confirmView
            ? Yup.string()
                  .required('Email address is required')
                  .email('Email address is not valid')
            : Yup.string(),
    },
    otp: {
        validation: confirmView
            ? Yup.string()
                  .required('Code is required')
                  .length(6, 'Code must be 6 digits')
            : Yup.string(),
    },
});
